module.exports = __webpack_public_path__ + "static/zuzhi-c8fa8178b58dbcb259d8bb493f2d97ea.png";